import { render, staticRenderFns } from "./OrderListHome.vue?vue&type=template&id=b9068d68&scoped=true&"
import script from "./OrderListHome.vue?vue&type=script&lang=js&"
export * from "./OrderListHome.vue?vue&type=script&lang=js&"
import style0 from "./OrderListHome.vue?vue&type=style&index=0&id=b9068d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9068d68",
  null
  
)

export default component.exports